import type {ContactNote} from 'api/v2';
import {NOT_REACHED} from '../ContactNoteForm/choices';

// Keyed on contact method, so a note missing its code by mistake reads blank
export const getServiceCodeLabel = ({
  contactMethod,
  serviceCode,
}: ContactNote): string => {
  if (contactMethod === NOT_REACHED) {
    return 'Not reached';
  }
  return serviceCode ?? '';
};
